<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="!formData.id ? '新增用户' : '编辑用户'"
    custom-class="project-dialog"
    :visible.sync="dialogVisible"
    :lock-scroll="false"
    top="3vh"
    width="50%"
  >
    <div class="px-xs">
      <el-form :model="formData" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="服务商模式" prop="isPartner">
          <el-switch v-model="formData.isPartner" > </el-switch>
        </el-form-item>
        <el-form-item
          v-if="formData.isPartner"
          label="特约商户号"
          prop="sub_mchid"
        >
          <el-input v-model="formData.sub_mchid" type="text"></el-input>
        </el-form-item>
        <el-row>
          <el-form-item
            v-if="formData.isPartner"
            label="是否抽成"
            prop="partnerOpenAccount"
          >
            <el-switch v-model="formData.partnerOpenAccount"> </el-switch>
            <a style="margin-left: 10px;" class="link"  target="_blank" href="https://www.saishiquan.cn/bgImg/fenzhang.jpg">确保对该特约商户授权分账，否则无法抽成</a>
          </el-form-item>
          <el-form-item
            v-if="formData.isPartner && formData.partnerOpenAccount"
            label="抽成比例"
            prop="partnerOpenAccount"
          >
            <el-input-number
              v-model="formData.partnerOpenAccounRate"
              controls-position="right"
              :min="0"
              :max="30"
              :precision="2"
            >
            </el-input-number>
            <span style="margin-left: 10px">%</span>
          </el-form-item>
        </el-row>
        <el-form-item label="所属角色" prop="roleId">
          <el-select v-model="formData.roleId" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="用户名" prop="matchPartyName">
          <el-input
            v-model="formData.matchPartyName"
            max="100"
            min="2"
          ></el-input>
        </el-form-item>
        <el-form-item label="账号" prop="user_name">
          <el-input v-model="formData.user_name" max="100" min="2"></el-input>
        </el-form-item>
        <el-form-item label="密码" required prop="password">
          <el-input v-model="formData.password" max="100" min="2"></el-input>
        </el-form-item>
        <span class="password-info"
          >大写字母，小写字母，数字，特殊符号 `@#$%^&*`~()-+=`
          中任意3项，长度大于6位的密码</span
        >
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false" size="small">取 消</el-button>
      <el-button type="primary" @click="submitForm" size="small"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "addRole",
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
    registTime: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    dialogVisible(value) {
      this.$emit("update:visible", value);
    },
    visible: {
      handler(value) {
        this.dialogVisible = value;
      },
      immediate: true,
    },
  },
  filters: {},
  data() {
    var validatePass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入密码"));
      }
      let reg =
        /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]/;
      if (value.length < 6) {
        callback(new Error("密码长度需要大于6位"));
      } else if (value.length > 50) {
        callback(new Error("密码长度需要小于50位"));
      } else if (!reg.test(value)) {
        callback(
          new Error(
            "大写字母，小写字母，数字，特殊符号 `@#$%^&*`~()-+=` 中任意3项密码"
          )
        );
      } else {
        callback();
      }
    };
    return {
      options: [],
      checkList: [],
      menuList: this.$store.state.menuList,
      dialogVisible: this.visible,
      // 绑定表单数据
      formData: JSON.parse(JSON.stringify(this.value)),
      rules: {
        roleId: [
          {
            required: true,
            message: "请选择角色",
            trigger: "blur",
          },
        ],
        matchPartyName: [
          {
            required: true,
            message: "请输入赛事方",
            trigger: "blur",
          },
          {
            min: 2,
            max: 15,
            message: "长度在 2 到 100个字符",
            trigger: "blur",
          },
        ],
        user_name: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur",
          },
          {
            min: 2,
            max: 15,
            message: "长度在 2 到 100个字符",
            trigger: "blur",
          },
        ],
        password: [
          {
            validator: validatePass,
            trigger: "blur",
          },
          {
            min: 2,
            max: 15,
            message: "长度在 2 到 100个字符",
            trigger: "blur",
          },
        ],
        // sub_mchid: [
        //   {
        //     required: true,
        //     message: "请输入特约商户号",
        //     trigger: "blur",
        //   },
        // ],
        partnerOpenAccount: [
          {
            required: true,
            message: "请输入抽成比例",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    if (!this.formData.id) {
      this.$set(this.formData, "isPartner", true);
      this.$set(this.formData, "partnerOpenAccounRate", 4);
      this.$set(this.formData, "partnerOpenAccount", true);
    } else {
      this.formData.isPartner = !!this.formData.isPartner;
      this.formData.partnerOpenAccount = !!this.formData.partnerOpenAccount;
    }
  },
  mounted() {
    this.getRole();
  },
  methods: {
    // 获取列表
    getRole() {
      this.$http
        .post("/sys/getRole", {
          page_size: 99999,
          page_index: 1,
          filter: this.filter,
        })
        .then((res) => {
          console.log(res);
          if (res.status !== 200) return;
          this.options = res.data.blogs;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    submitForm() {
      // 表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$http
            .post("/sys/saveUser", {
              ...this.formData,
            })
            .then((res) => {
              if (res.data.code == -1) {
                this.$message.error(res.data.message);
                return;
              } else {
                this.$message.success("已保存");
                this.dialogVisible = false;
                this.$emit("submitForm");
              }
            })
            .catch((err) => {
              this.$message.error("保存失败");
              this.dialogVisible = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang='less' scoped>
</style>